import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsFacilityHotelStore {
  @observable data = [];
  @observable images = [];

  @observable facilityHotels = [];
  @observable facilityHotel = null;

  @observable selectedfacilityHotel = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsFacilityHotels.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsFacilityHotels.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.facilityHotels = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsFacilityHotels.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selectedfacilityHotel = resp;
        this.selectedimages = [];
        if (this.selectedfacilityHotel.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selectedfacilityHotel.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selectedfacilityHotel.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Hotel Facility';
    return apiCaller.CmsFacilityHotels.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.facilityHotel = resp.data;

          if (this.facilityHotel.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.facilityHotel.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.facilityHotel.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Hotel Facility';
    this.facilityHotel = {
      'id': 0,
      'bannerUrl': '',
      'sort': 1,
      'facilityHotelLanguages': []
    };

    languages.map(language => {
      this.facilityHotel.facilityHotelLanguages.push({
        'id': 0,
        'facilityHotelId': 0,
        'languageId': language.id,
        'title': '',
        'briefDescription': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    this.facilityHotel.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsFacilityHotels.create(this.facilityHotel);
  }

  @action update() {
    this.updateLoading = true;

    this.facilityHotel.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsFacilityHotels.update(this.facilityHotel.id, this.facilityHotel);
  }

  @action delete(id) {
    return apiCaller.CmsFacilityHotels.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.facilityHotel.sort = value;
  }

  @action settitle(langId, value) {
    let lang = this.facilityHotel.facilityHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setbriefDescription(langId, value) {
    let lang = this.facilityHotel.facilityHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.briefDescription = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.facilityHotel.facilityHotelLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action setfacilityHotel(value) {
    this.facilityHotel = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.facilityHotel = null;

    this.selectedfacilityHotel = null;
    this.selectedimages = [];
  }
}

export default new CmsFacilityHotelStore();